/* This file is generated by scripts/generate-build-meta.js. */
export const GENERATED_BUILD_META = Object.freeze({
  "version": "1.6.17",
  "buildId": "20260806-1034-1d33ca9",
  "builtAt": "2026-08-06T05:04:48.948Z"
});
